import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { BaseTabs } from '@factorialco/f0-react/dist/experimental'
import { FeatureFlagAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import CollectionsBootstrap from 'modules/posts/lib/PostsCollectionsBootstrap'

const COMMUNITIES_FEATURE_FLAG = 'dev_communities_page'

const PostsRootPage = () => {
  const { navigation } = useNavigation()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data: featureFlagData, loading: featureFlagLoading } = useQuery(
    FeatureFlagAvailabilitiesDocument,
    {
      fetchPolicy: 'cache-first',
      variables: {
        companyId,
        featureNames: [COMMUNITIES_FEATURE_FLAG],
      },
    }
  )

  const isCommunitiesPageEnabled =
    featureFlagData?.features?.featuresConnection?.nodes?.find(
      (feature) => feature.name === COMMUNITIES_FEATURE_FLAG
    )?.enabled ?? false

  const shouldShowTabs = !featureFlagLoading && isCommunitiesPageEnabled

  return (
    <Box flexGrow>
      <CollectionsBootstrap>
        {shouldShowTabs && (
          <BaseTabs
            tabs={[
              {
                id: 'communities',
                index: true,
                label: i18n.t('posts.communities.tabs.communities'),
                href: navigation.communities.fullPath(),
              },
              {
                id: 'posts',
                label: i18n.t('posts.communities.tabs.posts'),
                href: navigation.communities.posts.fullPath(),
              },
            ]}
          />
        )}
        <Outlet />
      </CollectionsBootstrap>
    </Box>
  )
}

export default PostsRootPage
